import axios from 'axios'

export default {
    listForJournal: function (journalId) {
        return axios.get(`/api/journalipra/ListForJournal?journalId=${journalId}`, {});
    },
    find: function (id) {
        return axios.get('/api/journalipra/'+ id);
    },
    create: function (data) {
        return axios.post('/api/journalipra', data);
    },
    update: function (id, data) {
        return axios.put('/api/journalipra/' + id, data);
    },
    delete: function (id) {
        return axios.delete('/api/journalipra/' + id);
    },
    import(journalId, file) {
        let formData = new FormData();
        formData.append('journalId', journalId);
        formData.append('file', file);
        return axios.post( '/api/journalipra/import',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }
}